// extracted by mini-css-extract-plugin
module.exports = {"crosshairContainerCenter":"CrosshairWidget_crosshairContainerCenter__2VhDG"};